"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _classnames = _interopRequireDefault(require("classnames"));
var _Link = require("./Link");
require("./Item.scss");
const Item = _ref => {
  let {
    className,
    link,
    dataAttributes
  } = _ref;
  const {
    jsxElement
  } = link;
  const rootClassName = (0, _classnames.default)('cds-Dropdown-ListItem', {
    'cds-Dropdown-ListItem--JsxElement': !!jsxElement
  }, className);
  return /*#__PURE__*/_react.default.createElement("li", (0, _extends2.default)({
    className: rootClassName
  }, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes)), jsxElement || /*#__PURE__*/_react.default.createElement(_Link.Link, link));
};
exports.Item = Item;
//# sourceMappingURL=Item.js.map